import { Permission, notEqual } from '@cims-online/shared'
import { EditRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { IssueDispositionType } from '../../DispositionTypesContext/types'
import { EditFormItemsValues } from '../../components/CreateEditFormItems/types'
import CreateEditFormItems from '../../components/CreateEditFormItems'
import { useDispositionTypesContext } from '../../DispositionTypesContext'
import { useEditIssueDispositionTypeMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleEditNotification } from 'hooks/notificationHandler'

export function useEdit(): EditRowActionOptions<
  IssueDispositionType,
  EditFormItemsValues
> {
  const { refetch } = useDispositionTypesContext()
  const [edit] = useEditIssueDispositionTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      editIssueDispositionType: {
        dispositionType: { name },
      },
    }) => simpleEditNotification(name),
  })
  return {
    permission: Permission.EditIssueDispositionType,
    modal: {
      type: 'simple',
      body: <CreateEditFormItems />,
      recordName: 'name',
      initialValues: ({ name, description, nonApplicableIssueTypes }) => ({
        name,
        description,
        nonApplicableTypes: nonApplicableIssueTypes.map(
          ({ id, name, description, deleted }) => ({
            label: name,
            tooltip: description,
            deleted,
            value: id,
          })
        ),
      }),
      onOk: async (
        { id, ...dispositionType },
        { description, nonApplicableTypes, name }
      ) => {
        if (
          description === dispositionType.description &&
          name === dispositionType.name &&
          !notEqual(
            nonApplicableTypes?.map(({ value }) => value.toString()),
            dispositionType.nonApplicableIssueTypes.map(({ id }) => id)
          )
        )
          return
        await edit({
          variables: {
            input: {
              id,
              description,
              name,
              nonApplicableIssueTypeIds: nonApplicableTypes?.map(({ value }) =>
                value.toString()
              ),
            },
          },
        })
        refetch()
      },
    },
  }
}
